// Vendor-related filters

import { createEntityLookupFilter, createKeywordFilter } from './factories';
import type { FilterRegistry } from './types';

export const vendorFilters: FilterRegistry = {
	vendorKeywords: {
		...createKeywordFilter({
			label: 'Keywords',
			placeholder: 'Search by name, address, email, phone...',
			objectTable: 'vendor',
			listKeys: ['vendor'],
			fulltextFields: ['name', 'externalId', 'address1', 'email', 'phone'],
		}),
		queryParamName: 'vendorKeywords',
	},

	vendorCompanies: {
		...createEntityLookupFilter({
			label: 'Company',
			placeholder: 'Search companies...',
			apiEndpoint: '/companies/accessible',
			objectTable: 'vendor',
			fieldName: 'fk_company__id',
			listKeys: ['vendor'],
			displayFields: {
				id: 'id',
				primary: 'label',
			},
			colorScheme: 'purple',
		}),
		queryParamName: 'vendorCompanies',
		valueExtractor: {
			property: 'id',
			transform: 'number',
		},
	},

	vendors: {
		type: 'multi-select',
		label: 'Vendors',
		placeholder: 'Search vendors...',
		colorScheme: 'purple',
		searchable: true,
		loadOnFocus: true,
		displayFields: {
			id: '_id' as keyof unknown,
			primary: 'name' as keyof unknown,
		},
		apiEndpoint: '/vendors/search',
		queryParamName: 'vendors',
		multiple: true,
		queryMapping: {
			objectTable: 'vendor',
			fieldName: '_id',
			joinType: 'direct',
		},
		format: 'array',
		valueExtractor: {
			property: 'id',
			transform: 'number',
		},
		listKeys: ['vendor'],
	},
};
